package org.example.project.model

import androidx.compose.runtime.mutableStateListOf

class Board {

    val cells = List(10) {

        mutableStateListOf<CellState>().apply {

            repeat(10) {

                add(CellState.EMPTY)
            }
        }
    }
}